import CheckboxComponent, { CheckboxProps } from './CheckboxComponent.vue'

export type { CheckboxProps }

export default CheckboxComponent
